const AWS = require('aws-sdk')
import settingsService from './settingsService'

/**
 * VultrUploadService
 * Uploads audio files to the Vultr Object Storage liverun-bucket under the
 * "fallback/" prefix and sets them publicly accessible.
 *
 * Credentials are loaded lazily from the backend /settings endpoint via
 * settingsService.getAwsConfig() — the same pattern used by S3UploadService.
 */

let cachedConfig = null

async function getConfig () {
  if (cachedConfig) return cachedConfig
  cachedConfig = await settingsService.getAwsConfig()
  return cachedConfig
}

function buildS3Client (config) {
  return new AWS.S3({
    accessKeyId: config.accessKeyId,
    secretAccessKey: config.secretAccessKey,
    region: config.bucketRegion || 'us-east-1',
    endpoint: 'https://sgp1.vultrobjects.com',
    s3ForcePathStyle: true
  })
}

const BUCKET = 'liverun-bucket'
const VULTR_PUBLIC_BASE = 'https://sgp1.vultrobjects.com'

export default {
  /**
   * Upload an audio file to liverun-bucket/fallback/<filename> with public-read ACL.
   *
   * @param {Object}   file             - Object with { name: string, data: File|Blob }
   * @param {Function} onProgress       - Called with 0–100 progress percentage
   * @returns {Promise<string>}         - Resolves with the public URL of the uploaded file
   */
  async uploadFallbackAudio (file, onProgress) {
    const config = await getConfig()
    const s3 = buildS3Client(config)

    const key = 'fallback/' + file.name
    const contentType = resolveContentType(file.name)

    return new Promise((resolve, reject) => {
      const params = {
        Bucket: BUCKET,
        Key: key,
        Body: file.data,
        ContentType: contentType,
        ACL: 'public-read'
      }

      const request = s3.upload(params)

      request.on('httpUploadProgress', function (progress) {
        if (onProgress && progress.total) {
          const pct = Math.round((progress.loaded / progress.total) * 100)
          onProgress(pct)
        }
      })

      request.send(function (err) {
        if (err) {
          reject(err)
          return
        }
        // Build the public URL manually — Vultr path-style URLs are predictable
        const publicUrl = VULTR_PUBLIC_BASE + '/' + BUCKET + '/' + key
        resolve(publicUrl)
      })
    })
  }
}

function resolveContentType (fileName) {
  const lower = (fileName || '').toLowerCase()
  if (lower.endsWith('.mp3')) return 'audio/mpeg'
  if (lower.endsWith('.m4a')) return 'audio/mp4'
  if (lower.endsWith('.aac')) return 'audio/aac'
  return 'audio/mpeg'
}



// WEBPACK FOOTER //
// ./src/services/VultrUploadService.js